module.exports = __webpack_public_path__ + "static/media/elderDrakeSpecial1Area.eb3b491a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsters/elderDrakeSpecial1Area.svg
// module id = 136
// module chunks = 0